import { memo } from 'react';

import ErrorFilledIconSVG from '@/assets/alert-triangle-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IErrorFilledIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={ErrorFilledIconSVG} {...props} />
);

export const ErrorFilledIcon = memo(IErrorFilledIcon) as typeof IErrorFilledIcon;
